import { api } from 'api';
import { confirmInDangerousDev } from 'common/utils/dev';
import { requestErrorAction } from 'common/utils/requestErrorHandling';
import { Job, JobStatuses, JobTypes } from './actions';

export interface JobsParams {
  id?: number | number[];
  status?: JobStatuses[];
  date_param?: string[];
}

export const requestJobs = async (params?: JobsParams) =>
  await api.get<Job[]>('/jobs/', {
    params,
  });

export const doGetJobs = (params?: JobsParams) => async (dispatch) => {
  dispatch({ type: 'jobs/started' });

  try {
    const response = await requestJobs(params);
    dispatch({
      type: 'jobs/finished',
      jobs: response.data,
    });
  } catch (e) {
    dispatch(
      requestErrorAction({ type: 'jobs/finished' }, e, `Failed to get jobs.`)
    );
  }
};

export const requestJobLogs = async (id: Job['id']) =>
  await api.get<{ logs: string }>(`/jobs/${id}/logs`);

export const doGetJobLogs = (id: Job['id']) => async (dispatch) => {
  dispatch({ type: 'jobs/logs/started' });

  try {
    const response = await requestJobLogs(id);
    dispatch({
      type: 'jobs/logs/finished',
      id,
      logs: response.data.logs,
    });
  } catch (e) {
    dispatch(
      requestErrorAction(
        { type: 'jobs/logs/finished' },
        e,
        `Failed to get job logs.`
      )
    );
  }
};

export interface CreateJobsBodyData {
  date_from: string;
  date_to: string;
  job_types: JobTypes[];
}

export const requestCreateJobs = async (data: CreateJobsBodyData) =>
  confirmInDangerousDev(async () => await api.post<Job[]>('/jobs/', data));

export const doCreateJobs = (data: CreateJobsBodyData) => async (dispatch) => {
  dispatch({ type: 'jobs/create/started' });

  try {
    const response = await requestCreateJobs(data);
    dispatch({
      type: 'jobs/create/finished',
      jobs: response.data,
    });
  } catch (e) {
    dispatch(
      requestErrorAction(
        { type: 'jobs/create/finished' },
        e,
        `Failed to create jobs.`
      )
    );
  }
};

export const requestCancelJob = async (id: Job['id']) =>
  confirmInDangerousDev(async () => await api.post<Job>(`/jobs/${id}/cancel`));

export const doCancelJob = (id: Job['id']) => async (dispatch) => {
  dispatch({ type: 'jobs/cancel/started' });

  try {
    const response = await requestCancelJob(id);
    dispatch({
      type: 'jobs/cancel/finished',
      job: response.data,
    });
  } catch (e) {
    dispatch(
      requestErrorAction(
        { type: 'jobs/cancel/finished' },
        e,
        `Failed to cancel jobs.`
      )
    );
  }
};
